<template>
  <div class="cyber-login">
    <div class="cyber-login__logo">
      <img src="/resources/logos/BC_LOGO.png" alt="Business Club" />
      <div class="cyber-login__brand">BUSINESS CLUB</div>
    </div>

    <div class="cyber-login__card">
      <div class="cyber-login__card-glow"></div>
      <div class="cyber-login__header">
        <div class="cyber-login__header-line"></div>
        <h3>PASSWORD RECOVERY</h3>
        <p>Enter your username to reset</p>
      </div>

      <form @submit="onSubmit" class="cyber-login__form">
        <div class="cyber-input-group">
          <div class="cyber-input-icon">
            <i class="ion ion-email"></i>
          </div>
          <input
            type="text"
            class="form-control cyber-input"
            placeholder="Enter your Username"
            v-model="model.username"
          />
          <div class="cyber-input-border"></div>
        </div>

        <button
          v-if="!loading"
          type="submit"
          class="btn btn-success btn-block cyber-btn-glow"
        >
          <span>RECOVER NOW</span>
          <i class="mdi mdi-lock-reset ml-2"></i>
        </button>
        <button
          v-else
          type="submit"
          class="btn btn-success btn-block cyber-btn-glow"
          disabled
        >
          <span>PROCESSING</span>
          <i class="fa fa-circle-o-notch fa-spin ml-2"></i>
        </button>
      </form>

      <div class="cyber-login__footer">
        <p class="mb-2">
          Don't have an account?
          <router-link to="/register" class="cyber-link-gold ml-1">Sign Up</router-link>
        </p>
        <p class="mb-0">
          Want to sign in?
          <router-link to="/login" class="cyber-link-gold ml-1">Log In</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cyber-login { padding: 20px 0; }

.cyber-login__logo {
  text-align: center;
  margin-bottom: 30px;
}

.cyber-login__logo img {
  width: 100px;
  filter: drop-shadow(0 0 20px rgba(176, 154, 78, 0.4));
  animation: logoPulse 3s ease-in-out infinite;
}

.cyber-login__brand {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.75rem;
  color: rgba(194, 193, 184, 0.6);
  letter-spacing: 0.3em;
  margin-top: 10px;
}

.cyber-login__card {
  position: relative;
  background: rgba(37, 37, 37, 0.85);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border: 1px solid rgba(176, 154, 78, 0.12);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6), 0 0 30px rgba(176, 154, 78, 0.08);
}

.cyber-login__card-glow {
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, #7BBFB5, transparent);
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer { 0%, 100% { opacity: 0.6; } 50% { opacity: 1; } }

.cyber-login__header {
  padding: 30px 30px 0;
  text-align: center;
}

.cyber-login__header-line {
  width: 30px; height: 2px;
  background: #B09A4E;
  margin: 0 auto 15px;
  box-shadow: 0 0 8px rgba(176, 154, 78, 0.5);
}

.cyber-login__header h3 {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 1rem !important;
  color: #E0DFD8 !important;
  letter-spacing: 0.15em;
  margin-bottom: 5px;
}

.cyber-login__header p {
  color: rgba(154, 153, 143, 1);
  font-size: 0.85rem;
  margin: 0;
}

.cyber-login__form { padding: 25px 30px; }

.cyber-input-group {
  position: relative;
  margin-bottom: 18px;
}

.cyber-input-icon {
  position: absolute;
  left: 14px; top: 50%;
  transform: translateY(-50%);
  color: rgba(176, 154, 78, 0.5);
  z-index: 2;
}

.cyber-input {
  padding-left: 42px !important;
  background: rgba(26, 26, 26, 0.7) !important;
  border: 1px solid rgba(61, 61, 55, 0.8) !important;
  color: #E0DFD8 !important;
  border-radius: 10px !important;
  height: 48px !important;
  transition: all 0.3s ease !important;
}

.cyber-input:focus {
  border-color: #B09A4E !important;
  box-shadow: 0 0 0 2px rgba(176, 154, 78, 0.1), 0 0 20px rgba(176, 154, 78, 0.1) !important;
}

.cyber-input:focus + .cyber-input-border { opacity: 1; }

.cyber-input-border {
  position: absolute;
  bottom: 0; left: 10%; width: 80%; height: 1px;
  background: linear-gradient(90deg, transparent, #B09A4E, transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.cyber-link-gold {
  color: #B09A4E !important;
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.8rem !important;
  letter-spacing: 0.05em;
}

.cyber-btn-glow {
  height: 48px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem !important;
  letter-spacing: 0.12em;
}

.cyber-login__footer {
  padding: 0 30px 25px;
  text-align: center;
}

.cyber-login__footer p {
  color: #9A998F;
  font-size: 0.85rem;
}

@keyframes logoPulse {
  0%, 100% { filter: drop-shadow(0 0 15px rgba(176, 154, 78, 0.3)); }
  50% { filter: drop-shadow(0 0 30px rgba(176, 154, 78, 0.6)); }
}
</style>

<script>
import router from "@/router";

export default {
  name: "login",
  data() {
    return {
      loading: false,
      model: {
        username: "",
        password: "",
      },
    };
  },

  methods: {
    onSubmit(evt) {
      this.loading = true;
      evt.preventDefault();
      this.$http
        .post("/api/v1/client/pass_recoveries", this.model)
        .then(() => {
          this.$toasted.show(
            "Please check your email to get your new password",
            {
              position: "top-right",
              duration: 5000,
              type: "success",
              closeOnSwipe: true,
            }
          );
          this.loading = false;
          this.model = {};
        })
        .catch((error) => {
          this.$toasted.show(error.response.data.status, {
            position: "top-right",
            theme: "toasted-primary",
            duration: 5000,
            type: "error",
            closeOnSwipe: true,
          });
          this.loading = false;
        });
    },

    storeLogin(data) {
      let action;
      let firstPage = "dashboard?auth=true";
      action = async () => {
        await localStorage.setItem("auth_token", data.auth_token);
        await localStorage.setItem("user", JSON.stringify(data.user));
        await router.push(firstPage);
      };
      action();
    },
  },
};
</script>
